import $ from 'jquery'

function tutorialsShow($element, options) {

  // PRIVATE VARIABLES

  var $mainContainer = $element,
    $seeMoreToggler,
    seeMoreWasClicked = false,
    $moreObjective,
    $showManyWays,
    $manyWaysBlock;

  // PRIVATE METHODS

  // constructor
  function init() {
    SOPHIA.tutorial.id = options.packet_id;
    SOPHIA.tutorial.author_id = options.tutorial_author_id;
    SOPHIA.tutorial.censored = options.tutorial_censored;

    SOPHIA.publisher.publishingState.setState(options.publishingState);
    if ($('.playlistorial-other-actions-dropdown').length) {
      new SOPHIA.tutorial.otherActionsDropdown('.playlistorial-other-actions-dropdown');
    }

    $showManyWays = $('.many-ways-link-show', $mainContainer);
    $manyWaysBlock = $('.flexible-many-ways-row', $mainContainer);

    if (SOPHIA.loggedIn()) {
      SOPHIA.initPingator({ target: { id: options.packet_id, type: 'tutorial' } });
    }

    $('.section').each(function() {
      SOPHIA.initTutorialSections($(this))
    });

    // Video Section gets initialized once. It get broken being iterated.
    if ($('.videojs-player').length) {
      SOPHIA.videoJsPlayer()
    }

    $('.flexible-many-ways', $mainContainer).manyWaysPlayer();


    $seeMoreToggler = $('#see_more_toggle', $mainContainer);
    $moreObjective = $('.more-objective-link', $mainContainer);

    $(document).foundation();
    SOPHIA.ratingHistogram();
    bindDomEvents();
  }

  bindDomEventsTutorialRest();

  function bindDomEventsTutorialRest() {
    $('.flexible-right', $mainContainer).actionGearDark();

    $('.rating_wrapper', $mainContainer).ratingWidget();
  }

  function bindDomEvents() {
    $showManyWays.on('click', function () {
      $manyWaysBlock.toggleClass('show');
    });

    $mainContainer.on('click', '.mobile-open-link', function (e) {
      e.preventDefault();
      $('.mini-quiz-block').toggleClass('show');
    });

    // See More Tutorial Information Visibility Toggle
    $seeMoreToggler.on('click', function (e) {
      e.preventDefault();

      if (seeMoreWasClicked) { return; }

      var $this = $(this),
        $moreBlock = $('.see-more', $mainContainer);

      if ($moreBlock.length === 0) {
        // First Click, get contents
        seeMoreWasClicked = true;
        var xhrData = {
          url: $this.data('url'),
          type: 'get',
          dataType: 'html'
        };

        var callbacks = {
          afterSuccess: function (response) {
            seeMoreWasClicked = false;
            if (SOPHIA.xhrHasErrors(response) === false) {
              $moreBlock = $(response);
              $('.flexible-playlistorial-header-block', $mainContainer).append($moreBlock);
              toggleSeeMore($this, $moreBlock);
            }
          }
        };

        SOPHIA.sendXHR(xhrData, callbacks);

      } else {
        // Second Click, just toggle
        toggleSeeMore($this, $moreBlock);
      }
    });

    if ($('.objective').height() > 54) {
      $('.objective').addClass('hidden-text');
      $moreObjective.show().css({ 'display': 'block' });
    }

    $moreObjective.on('click', function (e) {
      e.preventDefault();

      $moreObjective.toggleClass('more').toggleClass('less');
      $('.objective', $mainContainer).toggleClass('hidden-text');
      $('.more-objective-link.more', $mainContainer).text('(more)');
      $('.more-objective-link.less', $mainContainer).text('(less)');
    });
  }

  function toggleSeeMore($link, $moreBlock) {
    var moreText = 'See More',
      lessText = 'See Less',
      linkText = $link.text();

    if (linkText == moreText) {
      $link.text(lessText).attr('title', lessText).addClass('opened');
      $moreBlock.slideDown('fast', function () {
        $(this).addClass('open');
      });
    } else if (linkText == lessText) {
      $link.text(moreText).attr('title', moreText).removeClass('opened');
      $moreBlock.slideUp('fast', function () {
        $(this).removeClass('open');
      });
    }
  }

  // run constructor
  init();

  // PUBLIC METHODS

  return {};

}

// jQuery plugin method
$.fn.tutorialsShow = function (options) {
  return this.each(function () {
    var $this = $(this);

    // If not already stored, store plugin object in this element's data
    if (!$this.data('tutorialsShow')) {
      $this.data('tutorialsShow', tutorialsShow($this, options));
    }
  });
};
